import { CloseOutlined } from '@ant-design/icons';
import { Drawer as AntDrawer, type DrawerProps } from 'antd';
import cx from 'classnames';
import styles from './index.less';

type IProps = Omit<DrawerProps, 'extra'>;

const Drawer: React.FC<IProps> = ({ className, ...rest }) => {
  return (
    <AntDrawer
      closable={false}
      className={cx(styles.container, className)}
      extra={
        <div onClick={rest?.onClose} className={styles.extra}>
          <CloseOutlined />
        </div>
      }
      {...rest}
    />
  );
};

export default Drawer;
